import { CloudAuthBloc } from "./bloc.cloud";
import { BoxAuthBloc } from "./bloc.box";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseAuthBloc } from "./bloc.base";
import environment from "@/config";

export default getService<BaseAuthBloc>(environment.nexus, {
    box: new BoxAuthBloc(),
    cloud: new CloudAuthBloc(),
});